module.exports = __webpack_public_path__ + "img/arrow-return-left.371fe63a.svg";